<template>
	<div class="login-page-container" a_id="login-page-container" extension-name="login-page">
		<div class="login-page-header" a_id="login-page-header">
			<span v-if="isTargetAgent">
				{{'LoginPage.AgentLogin' | translate}}
			</span>
			<span v-else>
				{{'LoginPage.LoginHeaderStart' | translate}} <b>{{'LoginPage.LoginHeaderEnd' | translate}}</b>
			</span>

		</div>
        <div class="mfa-page-sub-title" a_id="mfa-page-sub-title" v-if="qrcode">
            {{'LoginMFAPage.enableMFATitle' | translate}}
        </div>
        <div class="mfa-page-sub-title" a_id="mfa-page-sub-title" v-else>
            {{'LoginMFAPage.mfaTitle' | translate}}
        </div>
        <div class="mfa-page-scan-code" a_id="mfa-page-scan-code" v-if="qrcode">
            <div class="mfa-page-scan-code-text">{{'LoginMFAPage.scanCode' | translate}}</div>
            <img class="mfa-page-qrcode-image" :src="qrcode"/>
        </div>
		<form @submit.prevent.stop>
			<div class="mfa-page-field-label">{{ 'LoginMFAPage.codeChallenge' | translate }}</div>
			<login-page-field
				input-id="mfaCode"
				a_id="login-page-field-mfaCode"
				v-model="mfaCode"
				:imageType="'password'"
				:placeholder="'LoginMFAPage.codeChallengePlaceholder' | translate"
				:show-error-message="loginFailed"
				:error-message="(errorMessage || 'LoginPage.InvalidPasswordErrorMessage') | translate"
      />

			<div class="login-page-footer" a_id="login-page-footer">
				<button v-if="mfaCode && !locked"
						class="login-page-footer-button"
						@click.prevent.stop="mfaCodeClicked"
						a_id="login-page-footer-login-button">
					{{'LoginMFAPage.verifyButton' | translate}}
				</button>
				<button v-else disabled
						class="login-page-footer-button"
						a_id="login-page-footer-login-button-disabled">
					{{'LoginMFAPage.verifyButton' | translate}}
				</button>
			</div>
		</form>
	</div>
</template>

<script>
	import BasePage from './BasePage.vue';
	import LoginPageField from './LoginPageField.vue';
	import LoginService from '../services/LoginService';

	export default BasePage.extend( {
		name: "LoginMFAPage",
		props:{
			"currentAccountId" : {
				type: String,
				required: false
			}
		},
		methods: {
			mfaCodeClicked(){
				if( !this.mfaCode){
					return;
				}

        console.debug("validating mfa: ", this.mfaCode);
				LoginService.validateMFAcode('loginapplicationkey', this.mfaCode).then(
					(res) => {
						if (!LoginService.isAuthorized(res.data.roles)) {
							this.loginFailed = true;							
							this.errorMessage = this.translateService.getString('LoginPage.AgentAppLoginError');
							return;
						}											

						// set the Cookies && Local/Session storage(will be used by all the Apps)
						LoginService.updateLoginData(res.data["Access-Token"], res.data.userId, res.data["roles"]);

						this.loginFailed = false;

						//  redirect to previous APP
						LoginService.redirectToApp();
					},
					(err) => {
						this.showError(err.data);
						this.locked = err.data.message.indexOf("LockedException") != -1;
					}
				);
			},
			showError(data){
				this.loginFailed = true;

				if(data && data.message) {
					this.errorMessage = this.extractErrorMessage(data.message);
				}
				else {
					this.errorMessage = this.translateService.getString("LoginPage.GeneralError");
				}
			}
		},
		data(){
			return {
				accountId: '',
				userName: '',
				mfaCode: '',
				qrcode: '',
				loginFailed: false,
				locked: false,
				errorMessage: '',
				isTargetAgent: LoginService.isTargetAgentApp()
			};
		},
		watch: {
			accountId(){
				this.$emit('accountChanged', this.accountId)
			}
		},
		components: {
			LoginPageField
		},
		model: {
			// Parent can use "v-model" (by default, the expected event's name is "input")
			event: "navigate"
		},
		mounted(){
			var vm = this;
			console.log("LoginMFAPage: mounted");
			LoginService.getMFAQRcode('loginapplicationkey').then(
				(res) => {
					console.log("LoginMFAPage: got res " + res.data.qrcode);
					if(res.data.qrcode){
						vm.qrcode = 'data:image/png;base64, ' + res.data.qrcode;
					}else{
						vm.qrcode = false;
					}
				},
				(err) => {
					console.log("LoginMFAPage: ERROR got err " + err.data);
					this.showError(err.data);
				}
			);
		},
		dependencies: [{
			translateService : 'com.jacada.common.services.TranslateService'
		}]
	});

</script>

<style lang="scss">
	@import '../sass/loginPage.scss';
	@import '../sass/loginMFAPage.scss';
</style>


// WEBPACK FOOTER //
// src/app/LoginMFAPage.vue